export default __webpack_public_path__ + "static/media/nikkon.01098044.png";